import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_EYE: GlameraIconDefinition = {
  name: 'eye',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-eye-group">
      <path
        class="glm-eye-outline"
        d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0">
      </path>
      <circle class="glm-eye-pupil" cx="12" cy="12" r="3"></circle>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-eye-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './eye.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class EyeIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_EYE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
